import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { PageType } from '../../context/LayoutContext'
import { TextNav } from '../common/Text'
import Link from '../common/Link'

export type NavSPLinkProps = BoxProps & {
  to: PageType
  localizeKey: string
}

const NavSPLink: React.FC<NavSPLinkProps> = ({ to, localizeKey, ...others }) => {
  return (
    <>
      <Box {...others}>
        <Link to={to}>
          <TextNav localizeKey={localizeKey} lineHeight="1" />
        </Link>
      </Box>
    </>
  )
}

export default NavSPLink
